<script>
import { Bar, mixins } from 'vue-chartjs'

export default {
  extends: Bar,
  name: 'StackedBarChart',
  mixins: [mixins.reactiveProp],
  data() {
    return {
      isLoaded: false,
      chartOptions: {
        onClick: this.handleClick,
        animation: {
          duration: 500,
          easing: 'easeInOutSine'
        },
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true
            }
          ],
          yAxes: [
            {
              stacked: true,
              scaleLabel: {
                display: true,
                fontSize: 12,
                labelString: '% of correct and incorrect answer'
              }
            }
          ]
        },
        legend: {
          display: false,
          position: 'top',
          fullWidth: true,
          labels: {
            boxWidth: 15
          }
        },
        tooltips: {
          custom: function(tooltip) {
            if (!tooltip) return
            // disable displaying the color box;
            tooltip.displayColors = false
          },
          callbacks: {
            label: function() {
              return 'Click to view more information about the question'
            },
            title: function() {
              return ''
            }
          }
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        plugins: {
          datalabels: {
            formatter: value => {
              return value + '%'
            },
            color: '#fff',
            font: {
              size: 12
            }
          }
        }
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions)
  },
  methods: {
    handleClick(evt) {
      let activeElement = this.$data._chart.chart.getElementAtEvent(evt)
      if (typeof activeElement[0] !== 'undefined') {
        this.$emit('handleClickOnBarGraph', activeElement[0]._index)
      }
    },
    refresh() {
      this.renderChart(this.chartData, this.chartOptions)
    }
  }
}
</script>

<style lang="scss" scoped></style>
